import React, { Component } from 'react';
import { Navbar } from 'react-bootstrap';
import SideNav from '../sidenav/index';
import UserMenu from '../user-menu/index';
import NavBarFooter from './navbar/navbar-footer';
import igniteLogo from '../../assets/img/ignite_logo_alt.png';
import itukLogo from '../../assets/img/ITlogo-white.png';
import { USER_TYPE_ADMIN } from '../../data/userTypes';

class IgniteNavigation extends Component {
  state = {
    menuOpened: false,
  };

  handleToggle = () => {
    const { menuOpened } = this.state;

    this.setState({ menuOpened: !menuOpened });
  }

  render() {
    const {
      type, children, igniteLogoLink, hasRewardOutlet
    } = this.props;
    const { menuOpened } = this.state;
    const logoImage = hasRewardOutlet ? igniteLogo : itukLogo;

    return (
      <Navbar
        className="custom-sidebar"
        collapseOnSelect
        fluid
        onToggle={this.handleToggle}
      >
        <Navbar.Header id="navbar-header">
          <Navbar.Brand className={`sidebar-brand ${hasRewardOutlet ? '' : 'ituk-logo'}`}>
            <a href={igniteLogoLink || '/'}><img alt="Ignite Logo" src={logoImage} title="Ignite logo"/></a>
          </Navbar.Brand>
          <Navbar.Toggle/>
        </Navbar.Header>
        <SideNav type={type} menuOpened={menuOpened}/>
        <UserMenu type={type}/>
        {type !== USER_TYPE_ADMIN && <NavBarFooter type={type}/>}
        {children}
      </Navbar>
    );
  }
}

export default IgniteNavigation;



// WEBPACK FOOTER //
// ./src/components/layout/ignite-navigation.jsx